export const
  PFP_PART_COUNTS = {
    head: 87,
    neck: 10,
    body: 57,
    arms: 34,
    background: 6,
  }
;
